// Import reducers and operations and if needed types into this index file

import mainTimePeriod from './reducers';

// There is only one action and it is being exported from the operation. Not importing it here
export default mainTimePeriod;
